<template>
  <div class="network-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${networkId ? 'Editar' : 'Cadastrar'} Rede`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'network.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <network-form
        @submit="onSubmit"
        :id="networkId"
        :errors="errors"
        :saving="isSaving"
      ></network-form>
    </app-card>
  </div>
</template>

<script>
import NetworkForm from '@/components/Forms/NetworkForm.vue';
import NetworkService from '@/services/network.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'network-form-page',
  mixins: [ToastMixin],
  components: {
    NetworkForm,
  },
  data: () => {
    return {
      networkId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.networkId && this.save(data);
      this.networkId && this.update(this.networkId, data);
    },
    save(data) {
      this.isSaving = true;
      NetworkService.save(data)
        .then(() => {
          this.toastify('Rede cadastrada com sucesso!');
          this.$router.push({ name: 'network.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(message || 'Erro ao tentar cadastrar Rede.', 'error');
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      NetworkService.update(id, data)
        .then(() => {
          this.toastify('Rede atualizada com sucesso!');
          this.$router.push({ name: 'network.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(message || 'Erro ao tentar atualizar Rede.', 'error');
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.networkId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
